import { useEffect, useState } from "react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (isIOS) {
      if (!localStorage.getItem("sb_ios_hint_dismissed")) {
        const t = setTimeout(() => setIosHint(true), 2500);
        return () => clearTimeout(t);
      }
      return;
    }

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (iosHint) {
    return (
      <div className="sb-install" data-testid="ios-install-hint">
        <span>
          Install <strong>SundayBuilder™</strong>: tap <strong>Share</strong> then{" "}
          <strong>Add to Home Screen</strong>.
        </span>
        <button
          onClick={() => {
            localStorage.setItem("sb_ios_hint_dismissed", "1");
            setIosHint(false);
          }}
          aria-label="Dismiss"
          data-testid="ios-install-dismiss"
        >
          ✕
        </button>
      </div>
    );
  }

  if (!show) return null;

  return (
    <button className="sb-install-btn" onClick={install} data-testid="install-app-btn">
      Install App
    </button>
  );
}
